// Data layer for the invoice-time tax number check (RAT-1913).
import requestApi from 'utils/Request';
import {
  INVOICE_TAX_OVERRIDE,
  INVOICE_TAX_PRECHECK,
} from 'utils/StaticApiEndpoints';

// What the backend says should happen to each recipient - kept in sync with
// InvoiceTaxAction in
// revive-backend/src/common/constants/invoice-tax-gate.constants.ts.
export const INVOICE_TAX_ACTION = {
  ISSUE: 'ISSUE',
  ISSUE_WITH_WARNING: 'ISSUE_WITH_WARNING',
  ISSUE_UNVALIDATED: 'ISSUE_UNVALIDATED',
  BLOCK_OVERRIDABLE: 'BLOCK_OVERRIDABLE',
  BLOCK: 'BLOCK',
};

// Mirrors INVOICE_TAX_OVERRIDE_MIN_REASON_LENGTH on the backend, which rejects
// anything shorter - checked here too so the button says so before the request.
export const INVOICE_TAX_OVERRIDE_MIN_REASON = 10;

// Human labels for the registry verdicts - kept in sync with TinVerdict in
// revive-backend/src/common/constants/tin-validation.constants.ts.
export const TIN_VERDICT_LABEL = {
  VALID: 'Confirmed',
  INVALID_SIMILAR: 'Different legal name',
  VALID_REMOVED: 'Being removed',
  VALID_REVOKED: 'Revoked',
  INVALID: 'Not in the census',
  UNVERIFIED: 'Not verified',
  FORMAT_INVALID: 'Unusable number',
  NO_REGISTRY: 'No registry',
};

export const tinVerdictLabel = (verdict) =>
  TIN_VERDICT_LABEL[verdict] || verdict || 'Not checked';

export const isBlockedAction = (action) =>
  action === INVOICE_TAX_ACTION.BLOCK_OVERRIDABLE ||
  action === INVOICE_TAX_ACTION.BLOCK;

/**
 * Ask what the tax registry says about the recipients about to be invoiced.
 *
 * Returns null when the request itself fails. That is deliberate: the check is
 * an early warning, and the backend gate refuses the invoice on its own if the
 * number really is unusable. Blocking the operator because our own pre-check
 * call failed would be the same mistake as treating an unreachable AEAT as a
 * validation failure.
 */
export const precheckInvoiceTaxNumbers = async (payload) => {
  try {
    const { data } = await requestApi.post(INVOICE_TAX_PRECHECK, payload);
    return Array.isArray(data) ? data : null;
  } catch {
    return null;
  }
};

/**
 * Record the operator's decision to issue anyway. Unlike the pre-check this
 * one must surface its failure: nothing may be enqueued if the authorisation
 * was not stored, or the job would just fail on the gate.
 */
export const overrideInvoiceTaxNumber = (payload) =>
  requestApi.post(INVOICE_TAX_OVERRIDE, payload);
